import { PRICING_TYPES } from '@constants';
import {
  fixedNumber,
  formatAmount,
  formatDate,
  getCleanedUrlParams,
} from '@utils';

import { getCatalogRequestPayload } from 'helpers/catalog/cars';
import {
  CATALOG_CARS_PAGE_SIZE,
  DEFAULT_DROPDOWN,
  STATUSES,
} from './constants';

export const handleModelData = (models) => {
  if (!models || typeof models !== 'object') {
    return {};
  }

  const data = {};

  const uniqueManufacturers = [];

  const uniqueModels = [];

  const modelObj = {};

  Object.keys(models)?.forEach((dataManufacturer) => {
    const exists = uniqueManufacturers?.some((manufacturer) => {
      return manufacturer.value === models[dataManufacturer].slug;
    });

    if (exists) return;
    uniqueManufacturers?.push({
      value: models[dataManufacturer].slug,
      text: models[dataManufacturer].name,
    });
    Object.keys(models[dataManufacturer]?.models)?.forEach((model) => {
      const uniqueModelExists = uniqueModels?.some((uniqueModel) => {
        return (
          uniqueModel.value === models[dataManufacturer]?.models[model].slug &&
          uniqueModel.group === models[dataManufacturer]?.slug
        );
      });

      if (uniqueModelExists) return;
      if (modelObj[models[dataManufacturer]?.slug]) {
        modelObj[models[dataManufacturer]?.slug]?.push({
          value: models[dataManufacturer]?.models[model].slug,
          text: models[dataManufacturer]?.models[model].name,
          group: models[dataManufacturer]?.slug,
        });
      } else {
        modelObj[models[dataManufacturer]?.slug] = [
          {
            value: models[dataManufacturer]?.models[model].slug,
            text: models[dataManufacturer]?.models[model].name,
            group: models[dataManufacturer]?.slug,
          },
        ];
      }
      uniqueModels?.push({
        value: models[dataManufacturer]?.models[model].slug,
        text: models[dataManufacturer]?.models[model].name,
        group: models[dataManufacturer]?.slug,
      });
    });
  });

  data.models = uniqueModels;
  data.manufacturers = uniqueManufacturers;
  modelObj[undefined] = [];
  data.modelObj = modelObj;
  return data;
};

const handleVehicles = (array) => {
  if (!array) {
    return [];
  }

  const newArray = [...array];

  array?.forEach((item, index) => {
    const itemPrice = item.pricing?.find((pricingItem) => {
      return pricingItem?.type === PRICING_TYPES.open;
    });

    const row = {
      availability: item.availability || '-',
      brand: item?.properties?.brand || '-',
      category: item?.properties?.category || '-',
      edition: item?.properties?.edition?.trim() || '-',
      year: item?.properties?.year || '-',
      engineDisplacement: item?.properties?.engine?.displacement,
      fuelType: item?.properties?.engine?.fuelType || '-',
      image: item?.image?.url ? item.image?.url : '',
      initialPrice: itemPrice?.initialPrice
        ? formatAmount(fixedNumber(itemPrice.initialPrice))
        : '-',
      instastart: itemPrice?.instastart
        ? formatAmount(fixedNumber(itemPrice.instastart))
        : '-',
      kilometers: item.kilometers || '-',
      model: item?.properties?.model || '-',
      monthlyKilometers: item.monthlyKilometers || '-',
      name: item.name || '-',
      price: itemPrice?.price
        ? formatAmount(fixedNumber(itemPrice.price))
        : '-',
      status: item.published ? 'Published' : 'Unpublished',
      published: item.published,
      skuId: item.skuId || '-',
      tags: item.tags,
      transmission: item?.properties?.transmission || '-',
      updatedAt: item.updatedAt
        ? formatDate(item.updatedAt, 'dd/MM/yyyy')
        : '-',
      vendors: item.vendors,
      id: item.skuId,
      bodyType: item?.properties?.body?.type || '-',
      type: item?.type || '-',
      powerHp: item?.properties?.engine?.powerHp || '-',
      batterySize: item?.properties?.engine?.batterySize || '-',
      euroClass: item?.properties?.engine?.euroClass || '-',
      signUpFee: formatAmount(fixedNumber(item.signUpFee)) || '-',
      categoryClass: item?.properties?.categoryClass
        ? item?.properties?.categoryClass.replace(/-/g, ' ').toUpperCase()
        : '-',
      riskCategory: item?.properties?.riskCategory
        ? item?.properties?.riskCategory.replace(/-/g, ' ').toUpperCase()
        : '-',
    };

    newArray[index] = row;

    return newArray;
  });

  return newArray;
};

const handleEnums = (enumsObj) => {
  const returnObject = { ...enumsObj };

  returnObject.categoryOptions = [
    DEFAULT_DROPDOWN,
    ...(enumsObj?.categories?.map((item) => ({
      text: item.name,
      value: item.id,
    })) ?? []),
  ];

  returnObject.statusOptions = STATUSES;

  returnObject.brandOptions = [
    DEFAULT_DROPDOWN,
    ...(handleModelData(enumsObj?.models)?.manufacturers ?? []),
  ];

  return returnObject;
};

const getCatalogVehiclesQueryParamsAndPayload = ({
  page,
  pageSize,
  orderBy,
  order,
  others,
  query,
  modalFilters,
}) => {
  const params = {
    page,
    pageSize: parseInt(pageSize, 10) || CATALOG_CARS_PAGE_SIZE,
    orderBy,
    order,
    query,
  };

  const cleanedParams = getCleanedUrlParams(params);

  const payload = getCatalogRequestPayload(
    others,
    modalFilters?.modalFiltersRules
  );

  return { cleanedParams, payload };
};

export { handleVehicles, handleEnums, getCatalogVehiclesQueryParamsAndPayload };
